var map = {
	"./financial-data-management/bitemporal-solo-v2.svg": 351,
	"./financial-data-management/client-intelligence-v2.svg": 6046,
	"./financial-data-management/data-quality-v5.svg": 2339,
	"./financial-data-management/financial-professional-v3.svg": 7434,
	"./financial-data-management/fully-bitemporal.png": 827,
	"./financial-data-management/intelligent-investor-v3.svg": 815,
	"./financial-data-management/inverstor-intelligence-v4.svg": 800,
	"./financial-data-management/inverstor-intelligence-v5.svg": 8326,
	"./financial-data-management/professional-inteligence-v4.svg": 431,
	"./financial-data-management/professional-intelligence-v5.svg": 2331,
	"./icons/arrow-circle-right.png": 5980,
	"./icons/down-arrow.svg": 6798,
	"./icons/financial-proffesion-v3.svg": 7452,
	"./icons/left-arrow-32-px.png": 5658,
	"./icons/pink-arrow-right.png": 7538,
	"./icons/right-arrow-32-px.png": 1991,
	"./index/Difi.io-03.png": 7811,
	"./index/Difi.io_v3-01.jpg": 4679,
	"./index/Difi.io_v3-02.jpg": 6193,
	"./index/Difi.io_v3-03.jpg": 702,
	"./index/Difi.io_v4-01.jpg": 6125,
	"./index/Difi.io_v4-02.jpg": 8298,
	"./index/Difi.io_v4-03.jpg": 4019,
	"./index/bitemporal-stitched.svg": 8589,
	"./index/dashboard-screenshot.png": 2400,
	"./index/dashboard2.png": 5025,
	"./index/data-acquisition-v2.svg": 2060,
	"./index/data-quality-v2.svg": 4091,
	"./index/quality-v5.png": 8148,
	"./logos/DigitalFinanceLogoWithSpacing.png": 397,
	"./logos/DigitalFinanceLogoWithSpacingPink.png": 1386,
	"./logos/difiLogo.png": 9241,
	"./logos/difiLogoBiggerText.png": 2813,
	"./logos/difiLogoBiggerTextPink.png": 6934,
	"./logos/difiLogoIcon.png": 271,
	"./logos/digitalFinancialLogo.png": 3747,
	"./logos/digitalFinancialLogoPink.png": 1799,
	"./transparency/am-master-to-excel.gif": 1857,
	"./transparency/api-doc.gif": 8450,
	"./transparency/dashboard-linking.gif": 5089,
	"./transparency/dashboard-side-tab.png": 6483,
	"./transparency/db-views.png": 7048,
	"./transparency/file-to-data-alt.gif": 8663,
	"./transparency/file-to-data.gif": 9141,
	"./transparency/upload-file.gif": 1328,
	"./transparency/upload-source-file.gif": 8475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;